import { render, staticRenderFns } from "./ProductStat.vue?vue&type=template&id=35957e5e&lang=pug&"
import script from "./ProductStat.vue?vue&type=script&lang=js&"
export * from "./ProductStat.vue?vue&type=script&lang=js&"
import style0 from "./ProductStat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports